import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'store/store';
import {
    getAreasByTabId,
} from 'store/reducers/TabsSlice';
import {
    getTickerParams,
    setFilterParams
} from 'store/reducers/FilterSlice';
import {
    useLocation,
} from 'react-router-dom';
import {
    setFilteredColumns
} from 'store/reducers/quotes';
import TPH from 'utils/ticker-params-handler';

let observable_tab = '';

async function timeout(ms: number) {
    return new Promise((res, rej) => {
        const timeout = setTimeout(() => {
            res(true);
            clearTimeout(timeout);
        }, ms);
    })
}

async function cycle(callback: any, _timeout: number, id: string) {
    while (observable_tab === id) {
        callback();
        await timeout(_timeout);
    }
}

const Updater = ({
    activePage,
    currentTab,
    getAreasByTabId,
    filter_params,
    getTickerParams,
    active_page_id,
    filtered_columns,
    setFilteredColumns,
    filter_params_order,
    manual_query
}) => {
    const { pathname } = useLocation();

    React.useEffect(() => {
        const active_page_id = activePage?.id;
        if (!Array.isArray(filter_params) || (Array.isArray(filter_params) && !filter_params.length && pathname.includes('quotes'))) {
            getTickerParams().then(data => {
                //console.log('FILTERED,', data);
            })
        }

        if (!filtered_columns[active_page_id]) {
            if (!filter_params) {
                return;
            }
            const filter_params_names = filter_params.map(p => p.name);
            const data = activePage?.order.map(sec => ({
                id: sec.toString(),
                columns: filter_params_names
            }));
            //setFilteredColumns(data);
            
        }

    }, [activePage?.id, filter_params]);

    React.useEffect(() => {
        TPH.dropState();
    }, [activePage?.id]);
/*
    React.useEffect(() => {
        if (!filter_params_order || !filter_params) {
            return;
        }

        const sorted = filter_params.sort((a, b) => {
            return filter_params_order.indexOf(a.name) - filter_params_order.indexOf(b.name);
        });
        console.log('sorted', sorted);
        setFilterParams(sorted);
    }, [filter_params, filter_params_order]);
*/
    return <></>
}

export default connect((state: RootState) => ({
    activePage: state.quotesPage.activePage,
    currentTab: state.tabs.currentTab,
    filter_params: state.filter.filterParams,
    active_page_id: state.quotes.active_page_id,
    filtered_columns: state.quotes.filtered_columns,
    filter_params_order: state.filter.filterParamsOrder,
    manual_query: state.filter.manual_query
}), {
    getAreasByTabId,
    getTickerParams,
    setFilteredColumns
})(Updater);